import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import { useUserStore } from "@/stores/user";
import userMenuOptions from "@/utils/constants/userMenuOptions";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderUserPanel',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const userDropdownRef = ref({} as HTMLElement);
const userDropdownMenuRef = ref({} as HTMLElement);
const isUserDropdownOpened = ref<boolean>(false);
const onUserInfo = (): void => {
  isUserDropdownOpened.value = !isUserDropdownOpened.value;
};
const closeMenu = (): void => {
  isUserDropdownOpened.value = false;
};
onClickOutside(userDropdownRef, closeMenu, {
  ignore: [userDropdownMenuRef],
});
const onMenuItem = (action: string): void => {
  closeMenu();
  const actions: Record<string, () => void> = {
    onLogout: () => onLogout(),
  };
  const actionFunction = actions[action];
  if (actionFunction) {
    actionFunction();
  }
};
const onLogout = (): void => {
  userStore.clear();
};

const __returned__ = { userStore, userDropdownRef, userDropdownMenuRef, isUserDropdownOpened, onUserInfo, closeMenu, onMenuItem, onLogout, ref, get onClickOutside() { return onClickOutside }, get useUserStore() { return useUserStore }, get userMenuOptions() { return userMenuOptions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})